import { lazy } from "react";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
const MainRoutes = lazy(() => import("pages/pages"))

function App() {
  return (
    <div className="App">
      <MainRoutes/>
    </div>
  );
}

export default App;
